<template>
    <div class="fhv-centent"  v-loading="loading" >
        <h4 class="title-topic">ALG Setting</h4>
        <el-form 
            ref="From" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="small"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item v-show="item.show" :label="item.name" v-for="(item,index) in list" :key="index">
                <el-switch v-model="item.flag"  ></el-switch>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
            </el-form-item>   
        </el-form>

    </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      list: [
        { name: "TFTP Passthrough :", flag: true, show: false },
        { name: "FTP Passthrough :", flag: true, show: false },
        { name: "PPTP Passthrough :", flag: true, show: false },
        { name: "RTSP Passthrough :", flag: true, show: false },
        { name: "L2TP Passthrough :", flag: true, show: false },
        { name: "H323 Passthrough :", flag: true, show: false },
        { name: "SIP Passthrough :", flag: true, show: false },
        { name: "IPSEC Passthrough :", flag: true, show: false }
      ]
    };
  },
  methods: {
    getData() {
      this.loading = true;
      axios.post("/boafrm/getAlgStatus").then(res => {
        this.loading = false;
        var l2tp_algonoff = res.data.l2tp_algonoff;
        var ipsec_algonoff = res.data.ipsec_algonoff;
        var h323_algonoff = res.data.h323_algonoff;
        var rtsp_algonoff = res.data.rtsp_algonoff;
        var sip_algonoff = res.data.sip_algonoff;
        var ftp_algonoff = res.data.ftp_algonoff;
        var pptp_algonoff = res.data.pptp_algonoff;
        var tftp_algonoff = res.data.tftp_algonoff;
        if (l2tp_algonoff != 2) {
          this.list[0].show = true;
          if (l2tp_algonoff == 1) {
            this.list[0].flag = true;
          } else {
            this.list[0].flag = false;
          }
        }
        if (ipsec_algonoff != 2) {
          this.list[1].show = true;
          if (ipsec_algonoff == 1) {
            this.list[1].flag = true;
          } else {
            this.list[1].flag = false;
          }
        }
        if (h323_algonoff != 2) {
          this.list[2].show = true;
          if (h323_algonoff == 1) {
            this.list[2].flag = true;
          } else {
            this.list[2].flag = false;
          }
        }
        if (rtsp_algonoff != 2) {
          this.list[3].show = true;
          if (rtsp_algonoff == 1) {
            this.list[3].flag = true;
          } else {
            this.list[3].flag = false;
          }
        }
        if (sip_algonoff != 2) {
          this.list[4].show = true;
          if (sip_algonoff == 1) {
            this.list[4].flag = true;
          } else {
            this.list[4].flag = false;
          }
        }
        if (ftp_algonoff != 2) {
          this.list[5].show = true;
          if (ftp_algonoff == 1) {
            this.list[5].flag = true;
          } else {
            this.list[5].flag = false;
          }
        }
        if (pptp_algonoff != 2) {
          this.list[6].show = true;
          if (pptp_algonoff == 1) {
            this.list[6].flag = true;
          } else {
            this.list[6].flag = false;
          }
        }
        if (tftp_algonoff != 2) {
          this.list[7].show = true;
          if (tftp_algonoff == 1) {
            this.list[7].flag = true;
          } else {
            this.list[7].flag = false;
          }
        }
      });
    },
    save() {
      let postData = {
        l2tp_algonoff: 0,
        ipsec_algonoff: 0,
        h323_algonoff: 0,
        rtsp_algonoff: 0,
        sip_algonoff: 0,
        ftp_algonoff: 0,
        pptp_algonoff: 0,
        tftp_algonoff: 0,
        apply: "Save",
        "submit-url": "/algonoff.asp"
      };
      if (this.list[0].flag == true) {
        postData.l2tp_algonoff = "1";
      }
      if (this.list[1].flag == true) {
        postData.ipsec_algonoff = "1";
      }
      if (this.list[2].flag == true) {
        postData.h323_algonoff = "1";
      }
      if (this.list[3].flag == true) {
        postData.rtsp_algonoff = "1";
      }
      if (this.list[4].flag == true) {
        postData.sip_algonoff = "1";
      }
      if (this.list[5].flag == true) {
        postData.ftp_algonoff = "1";
      }
      if (this.list[6].flag == true) {
        postData.pptp_algonoff = "1";
      }
      if (this.list[7].flag == true) {
        postData.tftp_algonoff = "1";
      }
      this.loading = true;
      axios.post("/boafrm/setformALGOnOff", postData).then(res => {
        this.loading = false;
        this.$message.success(res.data.msg);
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>


